module.exports = __webpack_public_path__ + "static/media/ES-Upc.923e75b4.png";